import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const GoalsDashboard = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default GoalsDashboard